import PropTypes from "prop-types";
import { MenuItem, TextField, Typography } from "@material-ui/core"
import { Autocomplete } from "@material-ui/lab";
import useCrud from "../../../hooks/useCrud";
import { LoadingButton } from "../../Loading";
import { FORNECEDOR_VALUES_DEFAULT } from "../../../utils/financialHelper";

const SelectFornecedores = ({ onChange, fornecedor, isDelete: isDisabled }) => {
  const {
    action,
    buttonLabel,
    dadoFoiModificado,
    filterValue,
    isLoading,
    items: fornecedores,
    open,
    title,
    values,
    setAction,
    setButtonLabel,
    setDadoFoiModificado,
    setFilterValue,
    setItems,
    setValues,
    handleClose,
    handleDelete,
    handleEdit,
    handleOpen,
    handleSubmit,
    handleView,
  } = useCrud('/suppliers', FORNECEDOR_VALUES_DEFAULT, 'SelectFornecedores');

  const autoCompleteChange = (e, newValue) => {
    const customEvent = {
      target: {
        name: "suppliersId",
        value: newValue?.id
      }
    }
    onChange(customEvent)
  }
  
  return (
    <>
      {
        isLoading ? (
          <Typography variant="subtitle1">
            Carregando fornecedores...
            <LoadingButton />
          </Typography>
        ) : (
          <>
            <Autocomplete
              id='suppliersId'
              value={fornecedores.find(option => option.id === fornecedor) ?? null}
              fullWidth
              onChange={autoCompleteChange}
              disabled={isDisabled}
              options={fornecedores}
              getOptionLabel={(option) => option.tradeName}
              renderInput={(params) => <TextField {...params} label="Fornecedor" variant="outlined" InputLabelProps={{ shrink: true }} />}
            />
          </>
        )
      }
    </>
  );
};


SelectFornecedores.propTypes = {
  onChange: PropTypes.func.isRequired,
  fornecedor: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.number),
    PropTypes.oneOf([null]),
    PropTypes.number,
  ]),
  isDelete: PropTypes.bool.isRequired,
}

SelectFornecedores.defaultProps = {
  fornecedor: [],
}


export default SelectFornecedores;